"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbNumericTextbox = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shapes = require("../../skybase-core/shapes");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getClassNames = function getClassNames(props) {
  return (0, _classnames.default)('sb-numeric-textbox', props.className);
};
/**
 * @desc
 * Numeric and highly configurable textbox component.
 *
 * @param props
 * @returns {XML}
 * @constructor
 */


var SbNumericTextbox = /*#__PURE__*/function (_Component) {
  _inherits(SbNumericTextbox, _Component);

  var _super = _createSuper(SbNumericTextbox);

  function SbNumericTextbox(props) {
    var _this;

    _classCallCheck(this, SbNumericTextbox);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onValueChange", function (values) {
      _this.values = values;
      var onValueChange = _this.props.onValueChange;

      if (onValueChange) {
        onValueChange(values);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      var _this$values, _this$values$value;

      var _this$props = _this.props,
          onChange = _this$props.onChange,
          decimalSeparator = _this$props.decimalSeparator;
      var endsWithDecimal = (_this$values = _this.values) === null || _this$values === void 0 ? void 0 : (_this$values$value = _this$values.value) === null || _this$values$value === void 0 ? void 0 : _this$values$value.endsWith(decimalSeparator);

      if (!endsWithDecimal) {
        onChange(event, _this.values);
      }
    });

    _this.values = {};
    return _this;
  }

  _createClass(SbNumericTextbox, [{
    key: "render",
    value: function render() {
      var _formatPositiveAndNeg;

      var _this$props2 = this.props,
          integer = _this$props2.integer,
          fraction = _this$props2.fraction,
          onChange = _this$props2.onChange,
          negative = _this$props2.negative,
          decimalSeparator = _this$props2.decimalSeparator,
          thousandSeparator = _this$props2.thousandSeparator,
          positive = _this$props2.positive,
          selectOnFocus = _this$props2.selectOnFocus,
          value = _this$props2.value,
          inputRef = _this$props2.inputRef,
          rest = _objectWithoutProperties(_this$props2, ["integer", "fraction", "onChange", "negative", "decimalSeparator", "thousandSeparator", "positive", "selectOnFocus", "value", "inputRef"]);

      var classes = getClassNames(this.props);
      var thousand = thousandSeparator;

      if (decimalSeparator === thousandSeparator) {
        if (thousandSeparator !== ' ') {
          thousand = ' ';
        } else {
          thousand = ',';
        }
      }

      var formattedValue = (_formatPositiveAndNeg = (0, _utils.formatPositiveAndNegativeValue)(value, negative, positive, integer, decimalSeparator)) !== null && _formatPositiveAndNeg !== void 0 ? _formatPositiveAndNeg : '';
      return /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, _extends({}, rest, {
        getInputRef: inputRef,
        decimalScale: fraction,
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousand,
        allowNegative: negative,
        isAllowed: function isAllowed(currentValue) {
          return (0, _utils.isNumberValid)(currentValue, integer, positive);
        },
        className: classes,
        onValueChange: this.onValueChange,
        onChange: this.onChange,
        value: formattedValue
      }));
    }
  }]);

  return SbNumericTextbox;
}(_react.Component);

exports.SbNumericTextbox = SbNumericTextbox;

_defineProperty(SbNumericTextbox, "propTypes", {
  className: _propTypes.default.string,
  fraction: _propTypes.default.number,
  integer: _propTypes.default.number,
  negative: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onValueChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  selectOnFocus: _propTypes.default.bool,
  positive: _propTypes.default.bool,
  decimalSeparator: _propTypes.default.string,
  thousandSeparator: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string // One space is allowed - ' '
  ]),
  value: _propTypes.default.oneOfType([_propTypes.default.string, // Empty string is allowed.
  _propTypes.default.number]),
  inputRef: _shapes.PropTypeRef
});

_defineProperty(SbNumericTextbox, "defaultProps", {
  className: '',
  fraction: 10,
  integer: 20,
  negative: true,
  placeholder: null,
  selectOnFocus: false,
  positive: true,
  decimalSeparator: '.',
  thousandSeparator: '',
  value: '',
  onChange: function onChange() {},
  onValueChange: null,
  inputRef: function inputRef() {}
});
//# sourceMappingURL=sb-numeric-textbox.js.map